import './view.scss';

const displayEvent = new Event('blockDisplayed');
const hideEvent = new Event('blockHidden');

const setupClick = (block, triggerElement) => {
    const show = (event) => {
        event.stopPropagation();

        // If block is already active, hide it
        if (block.classList.contains('is-active')) {
            hide();
            return;
        }

        // Otherwise show it
        block.classList.add('is-active');
        triggerElement.forEach((element) => {
            element.classList.add('is-active');
        });
        setTimeout(() => {
            document.addEventListener('click', hide);
        }, 0);

        block.dispatchEvent(displayEvent);
    };

    const hide = (event = {}) => {
        if (block.contains(event.target)) {
            return;
        }

        block.classList.remove('is-active');
        triggerElement.forEach((element) => {
            element.classList.remove('is-active');
        });
        document.removeEventListener('click', hide);

        block.dispatchEvent(hideEvent);
    };

    triggerElement.forEach((element) => {
        element.addEventListener('click', show);
    });
};

const setupHover = (block, triggerElement) => {
    const allowSelfHover = block.dataset.allowSelfHover === 'true';

    const show = () => {
        block.classList.add('is-active');

        block.dispatchEvent(displayEvent);
    };

    const hide = (event) => {
        // Check if we're hovering over the block itself
        const isHoveringBlock = block.contains(event.relatedTarget);

        // Only remove the active class if:
        // 1. We're not hovering over the block itself, OR
        // 2. We are hovering over the block but self-hover is not allowed
        if (!isHoveringBlock || !allowSelfHover) {
            block.classList.remove('is-active');

            block.dispatchEvent(hideEvent);
        }
    };

    triggerElement.forEach((element) => {
        element.addEventListener('mouseenter', show);
        element.addEventListener('mouseleave', hide);
    });

    // Add event listeners to the block itself if self-hover is enabled
    if (allowSelfHover) {
        block.addEventListener('mouseenter', show);
        block.addEventListener('mouseleave', (event) => {
            // Only hide if we're not moving to another trigger element
            const movingToTrigger = Array.from(triggerElement).some((el) => el.contains(event.relatedTarget));
            if (!movingToTrigger) {
                block.classList.remove('is-active');
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.wp-block-base-dynamic-display');

    blocks.forEach((block) => {
        const interactionMode = block.dataset.interactionMode;
        const triggerClass = block.dataset.trigger;
        const triggerElement = document.querySelectorAll(`.${triggerClass}`);

        if (!triggerClass || !triggerElement || (interactionMode !== 'click' && interactionMode !== 'hover')) {
            return;
        }

        if (interactionMode === 'click') {
            setupClick(block, triggerElement);
        } else if (interactionMode === 'hover') {
            setupHover(block, triggerElement);
        }
    });
});
